import { render, staticRenderFns } from "./donation-technical-error.vue?vue&type=template&id=7184cf82&lang=pug"
import script from "./donation-technical-error.vue?vue&type=script&lang=js"
export * from "./donation-technical-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports